<template>
  <MetaButton data-testid="item-views" tooltip="Analytics" tooltip-placement="top-start" @click.prevent="requestTab('#analytics')">
    <Icon name="general.eye" size="sm" />
    <span>{{ visitsMessage }}</span>
  </MetaButton>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { Icon } from '@/storybook/icon';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { storeToRefs } from 'pinia';
import { useActiveTabTrigger } from '../../composables/useActiveTab';

const { publicVisitsCount } = storeToRefs(useViewerItemStore());
const { requestTab } = useActiveTabTrigger();

const visitsMessage = computed(() => {
  return publicVisitsCount.value === 1 ? `1 view` : `${publicVisitsCount.value} views`;
});
</script>
